module.exports = __webpack_public_path__ + "img/un.5e9d27b3.svg";